module.exports = __webpack_public_path__ + "static/img/1-1-2.b3cd0103.jpg";